import { CSSResultGroup, TemplateResult, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import componentStyles from './outline-bill-map.css.lit';
import { OutlineElement, SlotsController } from '@phase2/outline-core';

/**
 * The OutlineBillMap component
 * @element outline-bill-map
 */
@customElement('outline-bill-map')
export class OutlineBillMap extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  slots = new SlotsController(this);

  render(): TemplateResult {
    return html`
      <section class="interactive-document">
        <div class="user-markup">
          <slot name="description"></slot>
        </div>
        <div class="interactive-document__container">
          <figure class="interactive-document__figure">
            <slot name="figure"></slot>
            <slot name="popover-item"></slot>
          </figure>
        </div>
        <div class="accordion-wrapper">
          <slot name="accordion"></slot>
        </div>
      </section>
    `;
  }
}
